/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { CustomTableToolbar } from '../../libs/ui/TableToolbar';
import { DeleteModal } from '../../libs/ui/DeleteModal';
import { showSuccess } from '../../libs/utils/toasts';
import { 
  DeleteTestimonialPageDocument, 
  ITestimonialPage, 
  useTestimonialPagesQuery 
} from '../../graphql/generated/graphql';

const TestimonialPagesContainer = () => {
  const navigate = useNavigate();

  const [rows, setRows] = useState<Partial<ITestimonialPage>[]>([]);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState<number | undefined | null>(undefined);

  const [deleteTestimonialPage] = useMutation(DeleteTestimonialPageDocument, {});

  const { data, refetch } = useTestimonialPagesQuery({
    variables: {
      page: 1,
      pageSize: 1000
    },
    nextFetchPolicy: 'network-only'
  });

  useEffect(() => {
    if (data?.TestimonialPages.items) {
      setRows(data.TestimonialPages.items);
    }
  }, [data]);

  useEffect(()=> {
    refetch();
  },[])

  const handleDelete = async () => {
    try {
      const { data } = await deleteTestimonialPage({
        variables: { id: deleteId }
      });
      
      if (data?.DeleteTestimonialPage.status) {
        const filtered = rows.filter(item => item.id !== deleteId);
        setRows(filtered);
        setDeleteId(undefined);
        setDeleteModalVisible(false);
        showSuccess('The testimonial page was removed');
      }
    } catch (error) {
      console.error('Error deleting testimonial page:', error);
    }
  };

  return (
    <Box>
      <CustomTableToolbar
        title='Testimonial Pages'
        numSelected={0}
        onDelete={() => {}}
        onAdd={() => navigate('./new')}
      />
      <TableContainer component={Paper}>
        <Table aria-label='testimonial pages table'>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Page Title</TableCell>
              <TableCell>Headline</TableCell>
              <TableCell>URL</TableCell>
              <TableCell>Order</TableCell>
              <TableCell width={80}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.pageTitle}</TableCell>
                <TableCell>{row.headLine}</TableCell>
                <TableCell>{row.url}</TableCell>
                <TableCell>{row.order}</TableCell>
                <TableCell width={80} align='right'>
                  <Box display='flex'>
                    <IconButton onClick={() => navigate(`./${row.id}`)}>
                      <Tooltip title='Edit'>
                        <EditIcon />
                      </Tooltip>
                    </IconButton>
                    <IconButton 
                      onClick={() => { 
                        setDeleteId(row.id); 
                        setDeleteModalVisible(true);
                      }}
                    >
                      <Tooltip title='Delete'>
                        <DeleteIcon />
                      </Tooltip>
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <DeleteModal
        open={deleteModalVisible}
        title='Are you sure you want to delete this testimonial page?'
        onCancel={() => { 
          setDeleteModalVisible(false); 
          setDeleteId(undefined);
        }}
        onConfirm={handleDelete}
      />
    </Box>
  );
};

export default TestimonialPagesContainer;